export const PROMO_CAMPAIGNS_COLLECTION = 'promoCampaigns'

export const AME_CAMPAIGN_STATUS = {
  draft: 'draft',
  published: 'published',
  paused: 'paused',
  archived: 'archived',
}

export const AME_CAMPAIGN_STATUS_LABELS = {
  draft: 'Чернетка',
  published: 'Опублікована',
  paused: 'Призупинена',
  archived: 'Архівна',
}

export const AME_CAMPAIGN_SCOPE = {
  all: 'all',
  premium: 'premium',
  outlet: 'outlet',
}

export const AME_CAMPAIGN_SCOPE_LABELS = {
  all: 'Весь каталог',
  premium: 'Premium',
  outlet: 'Outlet',
}

export const AME_INCLUDE_MODE = {
  allInScope: 'allInScope',
  rules: 'rules',
  products: 'products',
}

export const AME_INCLUDE_MODE_LABELS = {
  allInScope: 'Увесь асортимент області',
  rules: 'Бренди та категорії',
  products: 'Конкретні товари',
}

export const AME_PROMOTION_TYPE = 'promoCode'
export const AME_PROMOTION_TYPE_LABEL = 'Промокод'
export const AME_PROMOTION_TYPE_OPTIONS = [{ value: AME_PROMOTION_TYPE, label: AME_PROMOTION_TYPE_LABEL }]

export const AME_PROMO_CODE_TYPE = 'discount'
export const AME_PROMO_CODE_TYPE_LABEL = 'Знижка'
export const AME_PROMO_CODE_TYPE_OPTIONS = [{ value: AME_PROMO_CODE_TYPE, label: AME_PROMO_CODE_TYPE_LABEL }]

export const AME_DISCOUNT_KIND = {
  percent: 'percent',
  fixed: 'fixed',
}

export const AME_DISCOUNT_KIND_LABELS = {
  percent: 'Відсоток',
  fixed: 'Фіксована сума',
}

export const AME_DISCOUNT_KIND_OPTIONS = [
  { value: AME_DISCOUNT_KIND.percent, label: AME_DISCOUNT_KIND_LABELS.percent },
  { value: AME_DISCOUNT_KIND.fixed, label: AME_DISCOUNT_KIND_LABELS.fixed },
]

export const AME_ISSUE_KIND = 'onRegistrationComplete'
export const AME_ISSUE_KIND_BY_PHRASE = 'byPhrase'
export const AME_ISSUE_KIND_LABEL = 'Автоматично після реєстрації'
export const AME_ISSUE_KIND_OPTIONS = [
  { value: AME_ISSUE_KIND, label: AME_ISSUE_KIND_LABEL },
  { value: AME_ISSUE_KIND_BY_PHRASE, label: 'За кодовою фразою' },
]

export const DEFAULT_AME_CAMPAIGN_PERCENT = 10
